import React from 'react';
import { clsx, clsb } from 'js/utils/classNames.util';
import { componentService } from 'js/services/component.service';

import { Label } from '../Label';
import * as Types from './types';

import '../../FormFields.scss';
import style from './InputGroup.scss';

export const InputGroup: React.FC<Types.IInputGroupProps> = ({
    label,
    children,
    className,
    classNames,
    direction = 'column',
    isLabelAsteriskEnabled,
    infoTooltip
}) => {
    return (
        <div className={`${clsb([style, classNames], ['inputGroup'])} ${className}`}>
            {label && (
                <Label
                    label={label}
                    infoTooltip={infoTooltip}
                    isLabelAsteriskEnabled={isLabelAsteriskEnabled}
                    className={clsb([style, classNames], ['inputGroupLabel'])}
                />
            )}

            <div className={clsx([clsb([style, classNames], ['inputContainer']), direction])}>{children}</div>
        </div>
    );
};

componentService.registerWebContentComponents({ InputGroup });
